import { HTTP } from "@/helpers/http-common"

const url = "/api/auditoria"

const get = (data) => new Promise((resolve, reject) => {
  HTTP.post(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

const details = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/details`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

export default {
  get
  , details
}



// WEBPACK FOOTER //
// ./src/services/auditoria/index.js